import React from 'react';
import { Helmet } from 'react-helmet';

class Meta extends React.Component {
  render() {
    const data = this.props.data ? (Array.isArray(this.props.data) ? this.props.data[0] : this.props.data) : null;

    const origin = 'https://project.amanur.com';

    let title = "Amanur Rahman - Software Engineer & Web Developer Projects";
    let desc = "Explore the engineering portfolio of Amanur Rahman featuring web applications, mobile apps, e-commerce solutions, and digital platforms.";
    let pageUrl = origin;
    let ogImage = `${origin}/image/amanur-og.png`;
    let ogType = "website";
    let jsonLd = null;

    if (data) {
      title = `${data.name} - Amanur Rahman Portfolio`;
      desc = data.desc || desc;
      if (data.url) {
        pageUrl = `${origin}/project/${data.url}`;
      }
      if (data.featuredImage && data.url) {
        ogImage = `${origin}/image/portfolio/${data.url}/${data.featuredImage}`;
      }
      ogType = "article";

      jsonLd = {
        "@context": "https://schema.org",
        "@type": "CreativeWork",
        "name": data.name,
        "description": data.desc,
        "url": pageUrl,
        "image": ogImage,
        "author": {
          "@type": "Person",
          "name": "Amanur Rahman",
          "url": "https://amanur.com"
        },
        "genre": data.category || "Software Development"
      };
    } else if (this.props.is404) {
      title = "404: Page Not Found - Amanur Rahman Portfolio";
      desc = "The requested project or page could not be found on project.amanur.com.";
      ogImage = `${origin}/image/404.png`;
    }

    return (
      <Helmet>
        {/* Primary Title and Meta Tags */}
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={desc} />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook / LinkedIn / WhatsApp */}
        <meta property="og:site_name" content="Amanur Rahman Project Portfolio" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:type" content={ogType} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:secure_url" content={ogImage} />
        <meta property="og:image:alt" content={title} />

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={ogImage} />
        <meta name="twitter:image:alt" content={title} />

        {/* Search Engine Crawling */}
        <meta name="robots" content="index, follow" />

        {/* JSON-LD Structured Data */}
        {jsonLd && (
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        )}
      </Helmet>
    );
  }
}

export default Meta;